export default "__VITE_ASSET__c6af7de1__"